module.exports = __webpack_public_path__ + "static/media/npr.org_2016_11_09_501451368_here-is-what-donald-trump-wants-to-do-in-his-first-100-days_plot.c8e690f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/npr.org_2016_11_09_501451368_here-is-what-donald-trump-wants-to-do-in-his-first-100-days_plot.png
// module id = 400
// module chunks = 0